export const DATA_FIX_STATUS = Object.freeze({
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  NEEDS_RESOLUTION: 'NEEDS_RESOLUTION',
  RESOLVED: 'RESOLVED',
  REJECTED: 'REJECTED',
  BLOCKED: 'BLOCKED',
  FAILED: 'FAILED',
  INVALID: 'INVALID',
});

export const ENTITY_TYPE = Object.freeze({ PLAYER: 'player', TEAM: 'team' });
export const ACTION_TYPE = Object.freeze({ MERGE: 'merge', DELETE: 'delete' });
export const SCOPE = Object.freeze({
  GLOBAL: 'global',
  PER_MATCH: 'per-match',
});

export const DATA_FIX_STATUS_INTENT = Object.freeze({
  [DATA_FIX_STATUS.PENDING]: 'none',
  [DATA_FIX_STATUS.IN_PROGRESS]: 'primary',
  [DATA_FIX_STATUS.NEEDS_RESOLUTION]: 'warning',
  [DATA_FIX_STATUS.PENDING_APPROVAL]: 'primary',
  [DATA_FIX_STATUS.BLOCKED]: 'danger',
  [DATA_FIX_STATUS.RESOLVED]: 'success',
  [DATA_FIX_STATUS.REJECTED]: 'danger',
  [DATA_FIX_STATUS.FAILED]: 'warning',
  [DATA_FIX_STATUS.INVALID]: 'danger',
});

const enrichLabel = (id, nameFromPayload) =>
  nameFromPayload ? `'${nameFromPayload}' (#${id})` : `#${id}`;

const sourceLabel = (request) => {
  const { entityType, sourceId, payload } = request;
  const nameKey =
    entityType === ENTITY_TYPE.TEAM ? 'wrongTeamName' : 'wrongPlayerName';
  return enrichLabel(sourceId, payload?.[nameKey]);
};

const targetLabel = (request) => {
  const { entityType, targetId, payload } = request;
  const nameKey =
    entityType === ENTITY_TYPE.TEAM ? 'correctTeamName' : 'correctPlayerName';
  return enrichLabel(targetId, payload?.[nameKey]);
};

export const buildActionSummary = (request) => {
  if (!request) return '';
  const { entityType, actionType, scope, matchId } = request;
  const src = sourceLabel(request);

  if (actionType === ACTION_TYPE.DELETE && scope === SCOPE.GLOBAL) {
    if (request.targetId) {
      return `Delete ${entityType} ${src}, moving its matches to ${targetLabel(request)}`;
    }
    return `Delete ${entityType} ${src} globally`;
  }
  if (actionType === ACTION_TYPE.MERGE && scope === SCOPE.GLOBAL) {
    return `Merge ${entityType} ${src} → ${targetLabel(request)} across all matches`;
  }
  if (actionType === ACTION_TYPE.MERGE && scope === SCOPE.PER_MATCH) {
    return `Merge ${entityType} ${src} → ${targetLabel(request)} in match #${matchId}`;
  }
  // fallback
  return `${actionType} ${entityType} ${src}${request.targetId ? ` → ${targetLabel(request)}` : ''}`;
};

export const buildPreviewCount = (preview) => {
  if (!preview?.matches?.length) return 'No matches affected';
  const total = preview.matches.length;
  return `Affects ${total} match${total !== 1 ? 'es' : ''}`;
};
